import Vue from 'vue'
import Router from 'vue-router'
import Login from '../page/login/Login'
// 单点登录
import loginGetUid from '../page/login/loginGetUid.vue'
import Home from '../page/oneMenu/Home'
import OneMenu from '../page/oneMenu/OneMenu'

// 智慧养护
import Maintenance from '../page/maintain/Maintenance'
import Main from '../page/maintain/main/Main'
import Core from '../page/maintain/core/Core'
import Crib from '../page/maintain/crib/Crib'
import Warehouse from '../page/maintain/warehouse/Warehouse'
import Plant from '../page/maintain/plant/Plant'
import Quality from '../page/maintain/quality/Quality'
// 品吸
import Pinxi from '../page/maintain/pinxi/Conservepinxi.vue'
import Warn from '../page/maintain/warn/Warn'
import Conserve from '../page/maintain/conserve/Conserve'
import Loss from '../page/maintain/loss/Loss'
import Task from '../page/maintain/task/Task'
import Report from '../page/maintain/report/Report'
import historyData from '../page/maintain/historyData/historyData'

// 包芯监控
import TimeMonitoring from '../page/maintain/core/TimeMonitoring'
import SingleCurve from '../page/maintain/core/SingleCurve'
import HistoryCurve from '../page/maintain/core/HistoryCurve'
import TimeAll from '../page/maintain/core/timeMonitoring/TimeAll'
import SensorHistory from '../page/maintain/core/timeMonitoring/SensorHistory'
import TimeSensor from '../page/maintain/core/timeMonitoring/TimeSensor'
import TimeTemperature from '../page/maintain/core/timeMonitoring/TimeTemperature'
import TimeWater from '../page/maintain/core/timeMonitoring/TimeWater'
import TimeLookSensor from '../page/maintain/core/timeMonitoring/TimeLookSensor'
import TimeUpdateSensor from '../page/maintain/core/timeMonitoring/timeUpdateSensor'
import TimeInCrib from '../page/maintain/core/timeMonitoring/TimeInCrib'
import SingleTem from '../page/maintain/core/singleCurve/SingleTem'
import SingleWater from '../page/maintain/core/singleCurve/SingleWater'
import HistoryTem from '../page/maintain/core/historyCurve/HistoryTem'
import HistoryWater from '../page/maintain/core/historyCurve/HistoryWater'

// 垛内监控
import CribTimeMonitoring from '../page/maintain/crib/TimeMonitoring'
import CribSingleCurve from '../page/maintain/crib/SingleCurve'
import CribHistoryCurve from '../page/maintain/crib/HistoryCurve'
import CribTimeAll from '../page/maintain/crib/timeMonitoring/TimeAll'
import CribSensorHistory from '../page/maintain/crib/timeMonitoring/SensorHistory'
import CribTimeOxygen from '../page/maintain/crib/timeMonitoring/TimeOxygen'
import CribTimeSensor from '../page/maintain/crib/timeMonitoring/TimeSensor'
import CribTimeCarbonDioxide from '../page/maintain/crib/timeMonitoring/TimeCarbonDioxide'
import CribTimeTemHum from '../page/maintain/crib/timeMonitoring/TimeTemHum'
import CribSingleOxygen from '../page/maintain/crib/singleCurve/SingleOxygen'
import CribSingleCarbonDioxide from '../page/maintain/crib/singleCurve/SingleCarbonDioxide'
import CribSingleTemHum from '../page/maintain/crib/singleCurve/SingleTemHum'
import CribHistoryOxygen from '../page/maintain/crib/historyCurve/HistoryOxygen'
import CribHistoryCarbonDioxide from '../page/maintain/crib/historyCurve/HistoryCarbonDioxide'
import CribHistoryTemHum from '../page/maintain/crib/historyCurve/HistoryTemHum'

// 仓间监控
import WareTimeMonitoring from '../page/maintain/warehouse/WareTimeMonitoring'
import WareSingleCurve from '../page/maintain/warehouse/WareSingleCurve'
import WareHistoryCurve from '../page/maintain/warehouse/WareHistoryCurve'
import WareTimeAll from '../page/maintain/warehouse/timeMonitoring/WareTimeAll'
import WareSensorHistory from '../page/maintain/warehouse/timeMonitoring/SensorHistory'
import WareTimeSensor from '../page/maintain/warehouse/timeMonitoring/WareTimeSensor'
import WareSingleTemHum from '../page/maintain/warehouse/singleCurve/WareSingleTemHum'
import WareHistoryAll from '../page/maintain/warehouse/historyCurve/WareHistoryAll'

// 虫情监控
import PlantIndex from '../page/maintain/plant/PlantIndex'
import ChangeHistory from '../page/maintain/plant/ChangeHistory'
import LookPlant from '../page/maintain/plant/LookPlant'
import LookPlantDeal from '../page/maintain/plant/LookPlantDeal'
import ApplyPlant from '../page/maintain/plant/ApplyPlant'
import AuditPlant from '../page/maintain/plant/AuditPlant'
import RegularPlant from '../page/maintain/plant/RegularPlant'
import HistoryPlant from '../page/maintain/plant/HistoryPlant'
import LookHistoryDetail from '../page/maintain/plant/LookHistoryDetail'
import NewPlant from '../page/maintain/plant/NewPlant'

// 质检管理
import InInspection from '../page/maintain/quality/InInspection'
import OutInspection from '../page/maintain/quality/OutInspection'
import AtInspection from '../page/maintain/quality/AtInspection'
import HistoryInspection from '../page/maintain/quality/HistoryInspection'
import ReportCard from '../page/maintain/quality/ReportCard'
import LookInspection from '../page/maintain/quality/LookInspection'
import AddInspection from '../page/maintain/quality/AddInspection'

// 预警管理
import WarnIndex from '../page/maintain/warn/WarnIndex'
import HistoryWarn from '../page/maintain/warn/HistoryWarn'
import SetWarn from '../page/maintain/warn/SetWarn'
import detailYu from '../page/maintain/warn/detailYu'
import StatisticalWarn from '../page/maintain/warn/StatisticalWarn'

// 养护计划
import PlanSingle from '../page/maintain/conserve/PlanSingle'
import DueSummery from '../page/maintain/conserve/DueSummery'
import History from '../page/maintain/conserve/History'
import SingleLook from '../page/maintain/conserve/SingleLook'
import SingleApproval from '../page/maintain/conserve/SingleApproval'
import SingleNew from '../page/maintain/conserve/SingleNew'
import Change from '../page/maintain/conserve/Change'
import DueLook from '../page/maintain/conserve/DueLook'

// 评吸管理
import PlanSinglepinxi from '../page/maintain/pinxi/PlanSingle'
import DueLookpinxi from '../page/maintain/pinxi/DueLook'

// 损耗统计
import Mildew from '../page/maintain/loss/Mildew'
import LookDetail from '../page/maintain/loss/LookDetail'
import LossDetail from '../page/maintain/loss/LossDetail'
import LookDetailView from '../page/maintain/loss/LookDetailView'
import LookDetailNew from '../page/maintain/loss/LookDetailNew'

// 任务中心
import Release from '../page/maintain/task/Release'

// 数据报表
import CarbonDioxideSensor from '../page/maintain/report/CarbonDioxideSensor'
import MoistureSensor from '../page/maintain/report/MoistureSensor'
import OxygenSensor from '../page/maintain/report/OxygenSensor'
import TemperatureAndHumiditySensor from '../page/maintain/report/TemperatureAndHumiditySensor'
import TemperatureSensor from '../page/maintain/report/TemperatureSensor'
import TypeStatistics from '../page/maintain/report/TypeStatistics'

// 历史数据
import CarbonDioxideSensorhistoryData from '../page/maintain/historyData/CarbonDioxideSensor'
import MoistureSensorhistoryData from '../page/maintain/historyData/MoistureSensor'
import OxygenSensorhistoryData from '../page/maintain/historyData/OxygenSensor'
import TemperatureAndHumiditySensorhistoryData from '../page/maintain/historyData/TemperatureAndHumiditySensor'
import TemperatureSensorhistoryData from '../page/maintain/historyData/TemperatureSensor'
import TypeStatisticshistoryData from '../page/maintain/historyData/TypeStatistics'
import SheBeiDetail from '../page/maintain/historyData/SheBeiDetail'
import DataDBi from '../page/maintain/historyData/DataDBi'

// 基础管理
import Management from '../page/basic/Management'
import Personnel from '../page/basic/personnel/Personnel'
import Storehouse from '../page/basic/storehourse/Storehouse'
import Equipment from '../page/basic/equipment/Equipment'
import EquipmentDetail from '../page/basic/equipment/EquipmentDetail'
import Material from '../page/basic/material/Material'
import MaterialDetail from '../page/basic/material/MaterialDetail'
import Log from '../page/basic/log/Log'

// 系统管理
import System from '../page/system/System'
import Department from '../page/system/Department'
import Role from '../page/system/Role'
import User from '../page/system/User'
import Menu from '../page/system/Menu'
Vue.use(Router)
export const constantRouterMap = [{
		path: '/',
		redirect: '/login'
	},
	{
		path: '/login',
		component: Login
	},
	// 单点
	{
		path: '/loginGetUid',
		component: loginGetUid
	},
	{
		path: '/oneMenu',
		component: OneMenu
	},
	{
		path: '/home',
		component: Home,
		children: [{
				path: '/maintenance',
				component: Maintenance,
				children: [{
						path: '/maintenance',
						name: 'Main',
						component: Main
					},
					{
						path: '/core',
						component: Core,
						children: [{
								path: '/core',
								component: TimeMonitoring,
								children: [{
										path: '/core',
										name: 'TimeAll',
										component: TimeAll
									},
									{
										path: '/core/timeMonitoring/timeSensor',
										name: 'TimeSensor',
										component: TimeSensor
									},
									{
										path: '/core/timeMonitoring/timeTemperature',
										name: 'TimeTemperature',
										component: TimeTemperature
									},
									{
										path: '/core/timeMonitoring/timeWater',
										name: 'TimeWater',
										component: TimeWater
									},
									{
										path: '/core/timeMonitoring/sensorHistory',
										name: 'SensorHistory',
										component: SensorHistory
									}
								]
							},
							{
								path: '/core/singleCurve',
								component: SingleCurve,
								children: [{
										path: '/core/singleCurve',
										name: 'SingleTem',
										component: SingleTem
									},
									{
										path: '/core/singleCurve/singleWater',
										name: 'SingleWater',
										component: SingleWater
									}
								]
							},
							{
								path: '/core/historyCurve',
								component: HistoryCurve,
								children: [{
										path: '/core/historyCurve',
										name: 'HistoryTem',
										component: HistoryTem
									},
									{
										path: '/core/historyCurve/historyWater',
										name: 'HistoryWater',
										component: HistoryWater
									}
								]
							}
						]
					},
					{
						path: '/timeLookSensor',
						name: 'TimeLookSensor',
						component: TimeLookSensor
					},
					{
						path: '/timeUpdateSensor',
						name: 'TimeUpdateSensor',
						component: TimeUpdateSensor
					},
					{
						path: '/timeInCrib',
						name: 'timeInCrib',
						component: TimeInCrib
					},
					{
						path: '/crib',
						component: Crib,
						children: [{
								path: '/crib',
								component: CribTimeMonitoring,
								children: [{
										path: '/crib',
										name: 'CribTimeAll',
										component: CribTimeAll
									},
									{
										path: '/crib/timeMonitoring/timeOxygen',
										name: 'CribTimeOxygen',
										component: CribTimeOxygen
									},
									{
										path: '/crib/timeMonitoring/timeSensor',
										name: 'CribTimeSensor',
										component: CribTimeSensor
									},
									{
										path: '/crib/timeMonitoring/timeCarbonDioxide',
										name: 'CribTimeCarbonDioxide',
										component: CribTimeCarbonDioxide
									},
									{
										path: '/crib/timeMonitoring/timeTemHum',
										name: 'CribTimeTemHum',
										component: CribTimeTemHum
									},
									{
										path: '/crib/timeMonitoring/sensorHistory',
										name: 'CribSensorHistory',
										component: CribSensorHistory
									}
								]
							},
							{
								path: '/crib/singleCurve',
								component: CribSingleCurve,
								children: [{
										path: '/crib/singleCurve',
										name: 'CribSingleOxygen',
										component: CribSingleOxygen
									},
									{
										path: '/crib/singleCurve/singleCarbonDioxide',
										name: 'CribSingleCarbonDioxide',
										component: CribSingleCarbonDioxide
									},
									{
										path: '/crib/singleCurve/singleCribSingleTemHum',
										name: 'CribSingleTemHum',
										component: CribSingleTemHum
									}
								]
							},
							{
								path: '/crib/historyCurve',
								component: CribHistoryCurve,
								children: [{
										path: '/crib/historyCurve',
										name: 'CribHistoryOxygen',
										component: CribHistoryOxygen
									},
									{
										path: '/crib/historyCurve/historyCarbonDioxide',
										name: 'CribHistoryCarbonDioxide',
										component: CribHistoryCarbonDioxide
									},
									{
										path: '/crib/historyCurve/historyTemHum',
										name: 'CribHistoryTemHum',
										component: CribHistoryTemHum
									}
								]
							}
						]
					},
					{
						path: '/warehouse',
						component: Warehouse,
						children: [{
								path: '/warehouse',
								component: WareTimeMonitoring,
								children: [{
										path: '/warehouse',
										name: 'WareTimeAll',
										component: WareTimeAll
									},
									{
										path: '/warehouse/timeMonitoring/timeSensor',
										name: 'WareTimeSensor',
										component: WareTimeSensor
									},
									{
										path: '/warehouse/timeMonitoring/sensorHistory',
										name: 'WareSensorHistory',
										component: WareSensorHistory
									}
								]
							},
							{
								path: '/warehouse/singleCurve',
								component: WareSingleCurve,
								children: [{
									path: '/warehouse/singleCurve',
									name: 'WareSingleTemHum',
									component: WareSingleTemHum
								}]
							},
							{
								path: '/warehouse/historyCurve',
								component: WareHistoryCurve,
								children: [{
									path: '/warehouse/historyCurve',
									name: 'WareHistoryAll',
									component: WareHistoryAll
								}]
							}
						]
					},
					{
						path: '/plant',
						component: Plant,
						children: [{
								path: '/plant',
								name: 'PlantIndex',
								component: PlantIndex
							},
							{
								path: '/plant/changeHistory',
								name: 'ChangeHistory',
								component: ChangeHistory
							},
							{
								path: '/plant/lookPlant',
								name: 'LookPlant',
								component: LookPlant
							},
							{
								path: '/plant/lookPlantDeal',
								name: 'LookPlantDeal',
								component: LookPlantDeal
							},
							{
								path: '/plant/applyPlant',
								name: 'ApplyPlant',
								component: ApplyPlant
							},
							{
								path: '/plant/auditPlant',
								name: 'AuditPlant',
								component: AuditPlant
							},
							{
								path: '/plant/regularPlant',
								name: 'RegularPlant',
								component: RegularPlant
							},
							{
								path: '/plant/historyPlant',
								name: 'HistoryPlant',
								component: HistoryPlant
							},
							{
								path: '/plant/lookHistoryDetail',
								name: 'LookHistoryDetail',
								component: LookHistoryDetail
							},
							{
								path: '/plant/newPlant',
								name: 'NewPlant',
								component: NewPlant
							}
						]
					},
					{
						path: '/quality',
						component: Quality,
						children: [{
								path: '/quality',
								name: 'InInspection',
								component: InInspection
							},
							{
								path: '/quality/outInspection',
								name: 'OutInspection',
								component: OutInspection
							},
							{
								path: '/quality/atInspection',
								name: 'AtInspection',
								component: AtInspection
							},
							{
								path: '/quality/historyInspection',
								name: 'HistoryInspection',
								component: HistoryInspection
							}
						]
					},
					{
						path: '/quality/reportCard',
						name: 'ReportCard',
						component: ReportCard
					},
					{
						path: '/quality/lookInspection',
						name: 'LookInspection',
						component: LookInspection
					},
					{
						path: '/quality/addInspection',
						name: 'AddInspection',
						component: AddInspection
					},
					{
						path: '/warn',
						component: Warn,
						children: [{
								path: '/warn',
								name: 'WarnIndex',
								component: WarnIndex
							},
							{
								path: '/warn/historyWarn',
								name: 'HistoryWarn',
								component: HistoryWarn
							},
							{
								path: '/warn/setWarn',
								name: 'SetWarn',
								component: SetWarn
							},
							{
								path: '/warn/detailYu',
								name: 'detailYu',
								component: detailYu
							}
						]
					},
					{
						path: '/warn/statisticalWarn',
						name: 'StatisticalWarn',
						component: StatisticalWarn
					},
					{
						path: '/conserve',
						component: Conserve,
						children: [{
								path: '/conserve',
								name: 'PlanSingle',
								component: PlanSingle
							},
							{
								path: '/conserve/dueSummery',
								name: 'DueSummery',
								component: DueSummery
							},
							{
								path: '/conserve/history',
								name: 'History',
								component: History
							},
							{
								path: '/conserve/change',
								name: 'Change',
								component: Change
							},
							{
								path: '/conserve/dueLook',
								name: 'DueLook',
								component: DueLook
							},
							{
								path: '/conserve/singleLook',
								name: 'SingleLook',
								component: SingleLook
							},
							{
								path: '/conserve/singleApproval',
								name: 'SingleApproval',
								component: SingleApproval
							},
							{
								path: '/conserve/singleNew',
								name: 'SingleNew',
								component: SingleNew
							}
						]
					},
					{
						path: '/pinxi',
						component: Pinxi,
						children: [{
								path: '/pinxi',
								name: 'PlanSinglepinxi',
								component: PlanSinglepinxi
							},
							{
								path: '/pinxi/dueLookpinxi',
								name: 'DueLookpinxi',
								component: DueLookpinxi
							}
						]
					},
					{
						path: '/loss',
						component: Loss,
						children: [{
								path: '/loss',
								name: 'Mildew',
								component: Mildew
							},
							{
								path: '/loss/lookDetail',
								name: 'LookDetail',
								component: LookDetail
							},
							{
								path: '/loss/lossDetail',
								name: 'LossDetail',
								component: LossDetail
							},
							{
								path: '/loss/lookDetailView',
								name: 'LookDetailView',
								component: LookDetailView
							},
							{
								path: '/loss/lookDetailNew',
								name: 'LookDetailNew',
								component: LookDetailNew
							}
						]
					},
					{
						path: '/task',
						name: 'Task',
						component: Task
					},
					{
						path: '/task/release',
						name: 'Release',
						component: Release
					},
					{
						path: '/report',
						component: Report,
						children: [{
								path: '/report',
								name: 'OxygenSensor',
								component: OxygenSensor
							},
							{
								path: '/report/CarbonDioxideSensor',
								name: 'CarbonDioxideSensor',
								component: CarbonDioxideSensor
							},
							{
								path: '/report/MoistureSensor',
								name: 'MoistureSensor',
								component: MoistureSensor
							},
							{
								path: '/report/TemperatureAndHumiditySensor',
								name: 'TemperatureAndHumiditySensor',
								component: TemperatureAndHumiditySensor
							},
							{
								path: '/report/TemperatureSensor',
								name: 'TemperatureSensor',
								component: TemperatureSensor
							},
							{
								path: '/report/TypeStatistics',
								name: 'TypeStatistics',
								component: TypeStatistics
							}
						]
					},
					{
						path: '/historyData',
						component: historyData,
						children: [{
								path: '/historyData',
								name: 'OxygenSensorhistoryData',
								component: OxygenSensorhistoryData
							},
							{
								path: '/historyData/CarbonDioxideSensor',
								name: 'CarbonDioxideSensorhistoryData',
								component: CarbonDioxideSensorhistoryData
							},
							{
								path: '/historyData/MoistureSensor',
								name: 'MoistureSensorhistoryData',
								component: MoistureSensorhistoryData
							},
							{
								path: '/historyData/TemperatureAndHumiditySensor',
								name: 'TemperatureAndHumiditySensorhistoryData',
								component: TemperatureAndHumiditySensorhistoryData
							},
							{
								path: '/historyData/TemperatureSensor',
								name: 'TemperatureSensorhistoryData',
								component: TemperatureSensorhistoryData
							},
							{
								path: '/historyData/TypeStatistics',
								name: 'TypeStatisticshistoryData',
								component: TypeStatisticshistoryData
							},
							{
								path: '/historyData/SheBeiDetail',
								name: 'SheBeiDetail',
								component: SheBeiDetail
							},
							{
								path: '/historyData/DataDBi',
								name: 'DataDBi',
								component: DataDBi
							}
						]
					}
				]
			},
			{
				path: '/management',
				component: Management,
				children: [{
						path: '/management',
						name: 'Personnel',
						component: Personnel
					},
					{
						path: '/storehouse',
						name: 'Storehouse',
						component: Storehouse
					},
					{
						path: '/equipment',
						name: 'Equipment',
						component: Equipment
					},
					{
						path: '/equipmentDetail',
						name: 'EquipmentDetail',
						component: EquipmentDetail
					},
					{
						path: '/material',
						name: 'Material',
						component: Material
					},
					{
						path: '/materialDetail',
						name: 'MaterialDetail',
						component: MaterialDetail
					},
					{
						path: '/log',
						name: 'Log',
						component: Log
					}
				]
			},
			{
				path: '/system/department',
				component: System,
				children: [{
						path: '/system/department',
						name: 'Department',
						component: Department
					},
					{
						path: '/system/role',
						name: 'Role',
						component: Role
					},
					{
						path: '/system/user',
						name: 'User',
						component: User
					},
					{
						path: '/system/menu',
						name: 'Menu',
						component: Menu
					}
				]
			}
		]
	}
]

export default new Router({
	routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js